import './Combobox.css';

import { IonLabel } from '@ionic/react';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import clsx from 'clsx';
import { ControlItemValue, StaticControlItem } from '../../types/types';
import { useTranslate } from '../../hooks/context/useTranslate';

type ComboboxProps = {
  value: ControlItemValue | null;
  onChange: (value: ControlItemValue) => void;
  options?: StaticControlItem[];
  label?: string;
  name?: string;
  disabled?: boolean;
  invalid?: boolean;
  isLoading?: boolean;
  onShow?: () => void;
  onBlur?: () => void;
  onFocus?: () => void;
};

const Combobox = ({
  value,
  onChange,
  options,
  label,
  name,
  disabled,
  invalid,
  isLoading = false,
  onShow,
  onBlur,
  onFocus,
}: ComboboxProps) => {
  const { t } = useTranslate();

  const handleChange = (e: DropdownChangeEvent) => {
    onChange(e.value as ControlItemValue);
  };

  return (
    <div className="combobox-container">
      {label && <IonLabel>{label}</IonLabel>}
      <Dropdown
        onBlur={onBlur}
        onFocus={onFocus}
        onShow={onShow}
        emptyMessage={t(isLoading ? 'loading...' : 'noRecordsReport')}
        panelClassName={clsx(
          'combobox-panel',
          isLoading && 'combobox-panel-loading'
        )}
        options={options}
        value={value}
        onChange={handleChange}
        placeholder={t('choose')}
        name={name}
        disabled={disabled}
        invalid={invalid}
        optionLabel="label"
        optionValue="value"
        filter
        className="combobox-dropdown"
      />
    </div>
  );
};

export default Combobox;
